import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Liquidate from "./liquidate/Liquidate";
import Home from "./home/Home";

const App = () => {
  return (
    <div className="relative w-full h-[500px] bg-[url('./assets/image/background.svg')]">
      <div className="bg-[#FFD8A088] h-auto">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/liquidate" element={<Liquidate />} />
          </Routes>
          <div className="h-12"></div>
        </BrowserRouter>
      </div>
    </div>
  );
};

export default App;
